import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { AppRouteGuard } from './app-route.guard';
import { AppRoutes } from './app-routes.interface';
import { MatDialogModule } from '@angular/material/dialog';
import { LandingComponent } from '@app/components/landing/landing.component';
import { AppRouteGuardHome } from '@app/app-route-home.guard';
import { PageId } from '@app/constants/page-id';
import { FenceResultAudienceComponent } from '@app/components/fence-result-audience/fence-result-audience.component';
import { RaceResultComponent } from '@app/components/race-result/race-result.component';
import { FinishComponent } from '@app/components/finish/finish.component';
import { StartComponent } from '@app/components/start/start.component';
import { FenseResultComponent } from '@app/components/fense-result/fense-result.component';
import { AdminRaceComponent } from '@app/components/admin/race/admin-race.component';
import { TrackMapComponent } from '@app/components/track-map/track-map.component';
import { ClientEventListnerComponent } from '@app/components/admin/client-event-listner/client-event-listner.component';
import { ManagerComponent } from '@app/components/manager/manager.component';
import { AdminHomeComponent } from '@app/components/admin/admin-home/admin-home.component';

const routes: AppRoutes = [
  { path: '', canActivate: [AppRouteGuardHome], component: LandingComponent },
  { path: `${PageId.fenceResultAudience}`, canActivate: [AppRouteGuard], component: FenceResultAudienceComponent },
  { path: `${PageId.raceResult}`, canActivate: [AppRouteGuard], component: RaceResultComponent },
  { path: `${PageId.finish}`, canActivate: [AppRouteGuard], component: FinishComponent },
  { path: `${PageId.start}`, canActivate: [AppRouteGuard], component: StartComponent },
  { path: `${PageId.fenseResult}`, canActivate: [AppRouteGuard], component: FenseResultComponent },
  { path: `${PageId.manager}`, canActivate: [AppRouteGuard], component: ManagerComponent }, //Toodo: replace with manager component
  { path: `${PageId.createRace}`, canActivate: [AppRouteGuard], component: AdminRaceComponent },
  { path: `${PageId.trackMap}`, canActivate: [AppRouteGuard], component: TrackMapComponent },
  { path: `${PageId.clientEvents}`, canActivate: [AppRouteGuard], component: ClientEventListnerComponent },
  { path: `${PageId.adminHome}`, canActivate: [AppRouteGuard], component: AdminHomeComponent },
];

@NgModule({
  imports: [
    RouterModule.forRoot(routes, { scrollPositionRestoration: 'disabled', useHash: false }),
    MatDialogModule
  ],
  exports: [RouterModule]
})
export class AppRoutingModule {
}
